<template>
  <div>
    <toolbar title="Add New Load"></toolbar>

    <v-stepper v-model="currentStep">
      <v-stepper-header>
        <v-stepper-step :complete="currentStep > 1" step = 1>
          Principal Stakeholders
        </v-stepper-step>
        <v-divider />

        <v-stepper-step :complete="currentStep > 2" step="2">
          Origin, Destination, Time
        </v-stepper-step>
        <v-divider />

        <v-stepper-step :complete="currentStep > 3" step="3">
          Optional Details
        </v-stepper-step>
        <v-divider />

        <v-stepper-step step="4">
          Confirmation
        </v-stepper-step>

      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-layout row wrap v-if="currentStep === 1">
            <v-flex xs12 md4 class="pa-3" v-if="true">
              <v-layout column>
                <v-list class="pb-0 mb-0" subheader>
                  <v-subheader>Created By</v-subheader>
                  <v-list-tile subheader>
                    <v-select
                      :items="originatorCompanies"
                      :readonly="(originatorCompanies.length || 0) == 1"
                      label="Select Account"
                      item-text="companyDisplayName"
                      item-value="companyId"
                      v-model="ownerCompanyId">
                    </v-select>
                  </v-list-tile>
                </v-list>
                <!-- here is where we create a edit customer component -->
                <v-list>

                  <v-subheader>Customer Invoicing</v-subheader>
                  <v-list-tile subheader>
                    <v-checkbox class="mb-0 pb-0" label="Export Customer Invoice" data-vv-name="loadCustomer" v-model="hasCustomerCompany" />
                  </v-list-tile>
                  <v-radio-group v-model="customerExportSelection" v-if="ownerCompany && ownerCompanyHasAccountingExportsEnabled">
                    <v-list-tile class="pl-2" v-if="customerGroups > 1">
                      <v-radio label="Site Account" value="platform" :disabled="!hasCustomerCompany"></v-radio>
                    </v-list-tile>
                    <v-list-tile class="pl-2" v-if="ownerCompanyHasQbConnected">
                      <v-radio label="Quickbooks Customer" value="quickbooks" :disabled="!hasCustomerCompany"></v-radio>
                    </v-list-tile>

                  </v-radio-group>
                  <v-list-tile v-if="customerExportSelection === 'platform' || customerGroups == 1">
                    <v-list-tile-avatar>
                      <img class="align-center"
                           :disabled="!hasCustomerCompany"
                           height="38" width="38"
                           :src="hasCustomerCompany ? '/static/location-pin2.png' : '/static/location-pin2-disabled.png'"/>

                    </v-list-tile-avatar>
                    <v-combobox
                      :disabled="!hasCustomerCompany"
                      :items="(search && search.length > 3) ? allCompanies : []"
                      :search-input.sync="search"
                      v-model="customerCompany"
                      :hide-no-data="!(search && search.length > 3)"
                      :error-messages="errors.first('customerCompany', 'customerValidations')"
                      data-vv-as="Customer Site Account"
                      data-vv-name="customerCompany"
                      data-vv-scope="customerValidations"
                      v-validate="{ rules: { required: hasCustomerCompany && customerExportSelection === 'platform' } }"
                      item-text="searchName"
                      class="mb-4 mr-3"
                      return-object
                      hide-details
                      label="Select Account">

                      <template slot="item" slot-scope="data">
                        <v-icon
                          :color="_.get(data, 'item.accountStatus.verified', null) ? 'green' : 'transparent'">
                          verified_user
                        </v-icon>
                        <span class="ml-1">{{data.item.searchName}}</span>
                      </template>

                      <template slot="no-data">
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              No results matching "<strong>{{ search }}</strong>".
                              Press <kbd>tab</kbd> to use this customer's name
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-combobox>
                  </v-list-tile>
                  <v-list-tile v-if="customerExportSelection === 'quickbooks' && ownerCompanyHasQbConnected"  >
                    <v-list-tile-action>
                      <img class="align-center"
                           :disabled="!hasCustomerCompany"
                           height="38" width="38"
                           :src="hasCustomerCompany ? '/static/C2QB_white_btn_sm_default.png' : '/static/C2QB_white_btn_sm_disabled.png'"/>

                    </v-list-tile-action>
                    <v-select-quickbooks-company :error-messages="errors.first('customer')"
                                                 data-vv-as="Customer"
                                                 data-vv-name="customer"
                                                 data-vv-scope="customerValidations"
                                                 v-validate="{ rules: { required: hasCustomerCompany && customerExportSelection === 'quickbooks' } }"
                                                 :company="ownerCompany"
                                                 v-model="customerQbCompany">
                    </v-select-quickbooks-company>
                  </v-list-tile>
                </v-list>
              </v-layout>
            </v-flex>
          </v-layout>

          <sticky-footer>
            <v-btn
              color="accent"
              @click="currentStep = 2"
              v-if="!isDisabled"
              :disabled="!stepOneCompleted">
              Continue
            </v-btn>
            <v-btn class="accent mr-0"
                   v-else
                   :disabled="true">
              Account Disabled
            </v-btn>

            <v-btn flat @click="$router.go(-1)">Cancel</v-btn>
          </sticky-footer>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-layout row wrap v-if="currentStep === 2">
            <v-flex xs12 md6 class="pa-3">

              <AddressSearch label="From (Origin Address)"
                             :showPlaceHolder="!originLocation"
                             v-model="originLocation"></AddressSearch>

              <AddressSearch label="To (Destination Address)"
                             :showPlaceHolder="originLocation && !destinationLocation"
                             v-model="destinationLocation"></AddressSearch>

              <date-picker
                input-id="pickupTimePicker"
                placeholder="Pickup Date"
                v-model="pickupTime">
              </date-picker>

              <v-text-field label="Number of Trucks"
                            class="mt-2" type="number"
                            v-model="loadCount"/>

              <div class="v-list__tile__sub-title">
                {{ distanceLabel(loadedMiles) }}. Based on Google Maps
              </div>
            </v-flex>

            <v-flex xs12 md6 class="pa-3">
              <LoadMap :origin-place-id="originPlaceId"
                       editPosition
                       @originChange="handleOriginChange($event)"
                       @destinationChange="handleDestinationChange($event)"
                       :destination-place-id="destinationPlaceId">
              </LoadMap>
            </v-flex>
          </v-layout>
          <sticky-footer>
            <v-btn
              color="accent"
              @click="currentStep = 3"
              v-if="!isDisabled"
              :disabled="!stepTwoCompleted">
              Continue
            </v-btn>
            <v-btn class="accent mr-0"
                   v-else
                   :disabled="true">
              Account Disabled
            </v-btn>

            <v-btn flat @click="currentStep = 1">Back</v-btn>
          </sticky-footer>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-layout wrap>
            <v-flex xs12 sm6 px-3>
              <div class="subheading font-weight-bold">
                Load Info
              </div>
              <v-textarea
                name="input-7-4"
                label="Dispatcher Instructions"
                v-model="dispatchInstructions"
              >
              </v-textarea>
            </v-flex>
            <v-flex xs12 sm6 px-3>
              <div class="subheading font-weight-bold">
                Requirements
              </div>
              <v-layout row>
                <v-list two-line>
                  <v-list-tile class="optional-details-tile">
                    <v-list-tile-avatar>
                      <icon-base width="35" height="35" icon-color="#352208"
                                 icon-name="hose"><icon-hose /></icon-base>
                    </v-list-tile-avatar>
                    <v-list-tile-content class="optional-details-checkbox">
                      <v-checkbox
                        label="Washout"
                        v-model="requireWashout"
                      />
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="optional-details-tile">
                    <v-list-tile-avatar>
                      <icon-base width="35" height="35" icon-color="#352208"
                                 viewBox="0 0 5 5" icon-name="wood">
                        <icon-wood />
                      </icon-base>
                    </v-list-tile-avatar>

                    <v-list-tile-content class="optional-details-checkbox">
                      <v-checkbox
                        label="Wood Chips"
                        v-model="requireWoodChips"
                      />
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile  class="optional-details-tile">
                    <v-list-tile-avatar>
                      <icon-base width="35" height="35" icon-name="cold" icon-color="#352208">
                        <icon-cold />
                      </icon-base>
                    </v-list-tile-avatar>
                    <v-list-tile-content class="optional-details-checkbox">
                      <v-checkbox
                        label="Weatherboards"
                        v-model="requireWeatherboards"
                      />
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-layout>
            </v-flex>
          </v-layout>
          <hr />
          <v-layout>
            <v-flex xs12 pa-3>
              <v-textarea
                name="input-7-4"
                label="Driver Instructions"
                v-model="driverInstructions">
              </v-textarea>
            </v-flex>
          </v-layout>
          <sticky-footer>
            <v-btn
              color="accent"
              :disabled="!stepThreeCompleted"
              @click="currentStep = 4">
              Continue
            </v-btn>

            <v-btn flat @click="currentStep = 2">Back</v-btn>
          </sticky-footer>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-layout wrap>
            <v-flex  xs12 sm6 pa-3>
              <div class="headline font-weight-bold">
                Load Details Confirmation
              </div>
            </v-flex>
            <v-flex xs12 sm6 pa-3 class="hide-when-sticky-footer-visible">
              <v-layout justify-end>
                <v-btn :loading="loadingBtn"
                       :disabled="!confirmationIsValid"
                       color="accent"
                       @click="postLoad()">
                  Save
                </v-btn>
                <v-btn flat @click="currentStep = 3">Back</v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 class="pl-3" v-if="currentStep === 4">
              <div class="subheading font-weight-bold">
                Origination and Invoicing
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 class="pl-3">
              <v-flex xs12 sm6 class="pl-3" v-if="currentStep === 4">
                <v-list class="pb-0 mb-0" subheader>
                  <v-subheader>Created By</v-subheader>
                  <v-list-tile subheader>
                    <v-select
                      :items="originatorCompanies"
                      :readonly="(originatorCompanies.length || 0) == 1"
                      label="Select Account"
                      item-text="companyDisplayName"
                      item-value="companyId"
                      v-model="ownerCompanyId">
                    </v-select>
                  </v-list-tile>
                  <v-subheader v-if="hasCustomerCompany">Load Rate</v-subheader>
                  <v-list-tile v-if="hasCustomerCompany">
                    <v-list-tile-content>
                      <span v-if="billableAmount != null && this.originPlaceId != null && this.destinationPlaceId != null">
                      ${{ loadedDistanceBilledRate}} per loaded {{ siteDistanceMeasureUnitLabel }}
                      </span>
                      <v-list-tile-sub-title>
                        {{ distanceLabel(loadedMiles) }}. Based on Google Maps
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="hasCustomerCompany">
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-flex>

            <v-flex xs12 sm4 class="pl-3">
              <!-- here is where we create a edit customer component -->
              <v-list class="pt-0 pb-0 mt-0 b-0">

                <v-subheader>Customer Invoicing</v-subheader>
                <v-list-tile class="mb-0 pb-0" >
                  <v-checkbox class="mb-0 pb-0" label="Export Customer Invoice" data-vv-name="loadCustomer" v-model="hasCustomerCompany" />
                </v-list-tile>
              </v-list>
              <v-list class="pt-0 mt-0" :two-line="hasCustomerCompany">
                <v-list-tile>
                  <v-list-tile-avatar><v-icon>attach_money</v-icon></v-list-tile-avatar>
                  <v-float-field label="Invoiced Amount"
                                 :disabled="!hasCustomerCompany"
                                 class="pr-3"
                                 v-validate="{ required: !hasCustomerCompany }"
                                 :error-messages="errors.first('customerInvoiceAmount', 'customerValidations')"
                                 data-vv-as="Customer Invoice Amount"
                                 data-vv-name="customerInvoiceAmount"
                                 data-vv-scope="customerValidations"
                                 v-model="billableAmount"/>
                <v-list-tile-action></v-list-tile-action>
                </v-list-tile>
                <v-radio-group v-model="customerExportSelection" v-if="ownerCompany && ownerCompanyHasAccountingExportsEnabled">
                  <v-list-tile class="pl-2" v-if="customerGroups > 1">
                    <v-radio label="Site Account" value="platform" :disabled="!hasCustomerCompany"></v-radio>
                  </v-list-tile>
                  <v-list-tile class="pl-2" v-if="ownerCompanyHasQbConnected">
                    <v-radio label="Quickbooks Customer" value="quickbooks" :disabled="!hasCustomerCompany"></v-radio>
                  </v-list-tile>

                </v-radio-group>
                <v-list-tile v-if="customerExportSelection === 'platform' || customerGroups == 1">
                  <v-list-tile-avatar>
                    <img class="align-center"
                         :disabled="!hasCustomerCompany"
                         height="38" width="38"
                         :src="hasCustomerCompany ? '/static/location-pin2.png' : '/static/location-pin2-disabled.png'"/>

                  </v-list-tile-avatar>
                  <v-combobox
                    :disabled="!hasCustomerCompany"
                    :items="(search && search.length > 3) ? allCompanies : []"
                    :search-input.sync="search"
                    v-model="customerCompany"
                    :hide-no-data="!(search && search.length > 3)"
                    :error-messages="errors.first('customerCompany', 'customerValidations')"
                    data-vv-as="Customer Site Account"
                    data-vv-name="customerCompany"
                    data-vv-scope="customerValidations"
                    v-validate="{ rules: { required: hasCustomerCompany && customerExportSelection === 'platform' } }"
                    item-text="searchName"
                    class="mb-4 mr-3"
                    return-object
                    hide-details
                    label="Select Account">

                    <template slot="item" slot-scope="data">
                      <v-icon
                        :color="_.get(data, 'item.accountStatus.verified', null) ? 'green' : 'transparent'">
                        verified_user
                      </v-icon>
                      <span class="ml-1">{{data.item.searchName}}</span>
                    </template>

                    <template slot="no-data">
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            No results matching "<strong>{{ search }}</strong>".
                            Press <kbd>tab</kbd> to use this customer's name
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-combobox>
                </v-list-tile>
                <v-list-tile v-if="customerExportSelection === 'quickbooks' && ownerCompanyHasQbConnected"  >
                  <v-list-tile-action>
                    <img class="align-center"
                         :disabled="!hasCustomerCompany"
                         height="38" width="38"
                         :src="hasCustomerCompany ? '/static/C2QB_white_btn_sm_default.png' : '/static/C2QB_white_btn_sm_disabled.png'"/>

                  </v-list-tile-action>
                  <v-select-quickbooks-company :error-messages="errors.first('customer')"
                                               data-vv-as="Customer"
                                               data-vv-name="customer"
                                               data-vv-scope="customerValidations"
                                               v-validate="{ rules: { required: hasCustomerCompany && customerExportSelection === 'quickbooks' } }"
                                               :company="ownerCompany"
                                               v-model="customerQbCompany">
                  </v-select-quickbooks-company>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs12 sm2/>

            <v-flex xs12 sm6 class="pa-3">
              <div class="subheading font-weight-bold">
                Origin, Destination, Time
              </div>

              <AddressSearch label="From (Origin Address)"
                             :showPlaceHolder="!originLocation"
                             v-model="originLocation"></AddressSearch>

              <AddressSearch label="To (Destination Address)"
                             :showPlaceHolder="originLocation && !destinationLocation"
                             v-model="destinationLocation"></AddressSearch>

              <date-picker
                input-id="pickupTimePickerPreview"
                placeholder="Pickup Date"
                v-model="pickupTime">
              </date-picker>

              <v-text-field
                label="Number of Trucks"
                class="mt-3"
                type="number"
                v-model="loadCount"/>
            </v-flex>

            <v-flex sm6 class="pa-3">
              <LoadMap :origin-place-id="originPlaceId"
                       editPosition
                       @originChange="handleOriginChange($event)"
                       @destinationChange="handleDestinationChange($event)"
                       :destination-place-id="destinationPlaceId">
              </LoadMap>
            </v-flex>
          </v-layout>
          <hr />
          <v-layout wrap>
            <v-flex xs12 sm6 pa-3>
              <div class="subheading font-weight-bold">
                Load Info
              </div>
              <v-textarea
                name="input-7-4"
                label="Dispatcher Instructions"
                v-model="dispatchInstructions">
              </v-textarea>
            </v-flex>
            <v-flex xs12 sm6 pa-3>
              <div class="subheading font-weight-bold">
                Requirements
              </div>
              <v-layout row>
                <v-list two-line>
                  <v-list-item>
                    <v-list-item-avatar>
                      <icon-base width="35" height="35" icon-color="#352208"
                                 icon-name="hose"><icon-hose /></icon-base>
                    </v-list-item-avatar>
                    <v-list-item-content class="checkbox-content">
                      <v-checkbox
                        label="Washout"
                        v-model="requireWashout"
                        hide-details
                      />
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-avatar>
                      <icon-base width="35" height="35" icon-color="#352208"
                                 viewBox="0 0 5 5" icon-name="wood">
                        <icon-wood />
                      </icon-base>
                    </v-list-item-avatar>
                    <v-list-item-content class="checkbox-content">
                      <v-checkbox
                        class="no-messages"
                        label="Wood Chips"
                        v-model="requireWoodChips"
                        hide-details
                      />
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-avatar>
                      <icon-base width="35" height="35" icon-name="cold" icon-color="#352208">
                        <icon-cold />
                      </icon-base>
                    </v-list-item-avatar>
                    <v-list-item-content class="checkbox-content">
                      <v-checkbox
                        label="Weatherboards"
                        v-model="requireWeatherboards"
                        hide-details
                      />
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-layout>
            </v-flex>
          </v-layout>
          <hr />
          <v-layout>
            <v-flex xs12 pa-3>
              <v-textarea
                name="input-7-4"
                label="Driver Instructions"
                v-model="driverInstructions">
              </v-textarea>
            </v-flex>
          </v-layout>
          <sticky-footer>
            <v-btn :loading="loadingBtn"
                   :disabled="!confirmationIsValid"
                   color="accent"
                   @click="postLoad()">
              Save
            </v-btn>

            <v-btn flat @click="currentStep = 3">Back</v-btn>
          </sticky-footer>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <explain-this :video="'post-load'" />
  </div>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import ExplainThis from '@/components/ExplainThis';
import Toolbar from '@/components/Toolbar';
import LoadMap from '@/components/LoadMap';
import StickyFooter from '@/components/StickyFooter';
import AddressSearch from '@/components/AddressSearch';
import VFloatField from '@/components/VFloatField';
import DatePicker from '@/components/DatePicker';
import IconBase from '@/components/IconBase';
import IconHose from '@/components/icons/IconHose';
import IconWood from '@/components/icons/IconWood';
import IconCold from '@/components/icons/IconCold';
import {
  accountHasCreateListingPermission,
  accountHasOfficePermission,
} from '@/store/permissions';

import {
  isTruckingCompany,
  hasCDNMembers,
  hasProducerInfo,
} from '@/types/models/company';

import { loadsTab } from '@/types';
import * as Timestamps from '@/types/timestamp';
import pluginMixin from '@/mixins/pluginMixin';
import unitsOfMeasurePlugin from '@/mixins/unitsOfMeasurePlugin';
import VSelectQuickbooksCompany from '../components/qb/SelectQuickbooksCompany.vue';
import quickbooksMixin from '../mixins/quickbooksMixin';
import VQuickbooksBtn from '../components/qb/QuickbooksButton.vue';
import companyPluginsMixin from '../mixins/companyPluginsMixin';

export default {
  data() {
    return {
      currentStep: 1,
      ownerCompanyId: null,
      pickupTimeMenu: false,
      conciergeUserId: null,
      originLocation: null,
      destinationLocation: null,
      billableAmount: null,
      loadCount: null,
      loadedMiles: null,
      driverInstructions: '',
      pickupTime: null,
      minDatetime: new Date().toISOString(),
      requireWashout: false,
      requireWeatherboards: false,
      requireWoodChips: false,
      dispatchInstructions: '',
      assignedTruckingCompanyId: null,
      createLoadBoardPosting: false,
      originPlaceId: null,
      destinationPlaceId: null,
      loadingBtn: false,
      cdnMembers: [],
      selectedMembers: [],
      isCdnDispatch: null,
      includeCustomerOnLoad: true,
      search: null,
      hasCustomerCompany: false,
      customerExportSelection: "platform",
      customerCompany: null,
      customerQbCompany: null,
      loadingCompanies: false,
    };
  },
  mixins: [
    pluginMixin,
    unitsOfMeasurePlugin,
    quickbooksMixin,
    companyPluginsMixin,
  ],
  components: {
    VQuickbooksBtn,
    VSelectQuickbooksCompany,
    DatePicker,
    Toolbar,
    AddressSearch,
    IconBase,
    IconHose,
    IconWood,
    IconCold,
    VFloatField,
    LoadMap,
    StickyFooter,
    ExplainThis,
  },
  computed: {
    ...mapState('applications', [
      'currentUser',
      'loading',
    ]),
    ...mapState('companies', {
      visibleCompanies: 'companies',
      company: 'company',
    }),
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapGetters('companies', {
      allCompanies: 'catalog',
      allTruckingCompanies: 'allTruckingCompanies',
    }),
    _() {
      return _;
    },
    invalidLoadRate() {
      return this.hasCustomerCompany
        ? this.billableAmount == null || this.billableAmount == undefined || this.billableAmount === ""
        : false;
    },
    stepOneCompleted() {
      let loadCustomer = !this.hasCustomerCompany;
      if (this.hasCustomerCompany) {
        if (this.customerExportSelection === 'platform'){
          loadCustomer = !!this.customerCompany;
        } else if (this.customerExportSelection === 'quickbooks') {
          loadCustomer = !!this.customerQbCompany;
        }
      }

      return this.ownerCompanyId && loadCustomer;
    },
    stepTwoCompleted() {
      return this.pickupTime && this.loadCount > 0 &&
        this.originLocation && this.destinationLocation;
    },
    stepThreeCompleted() {
      return true;
    },
    confirmationIsValid() {
      return this.stepOneCompleted
          && this.stepTwoCompleted
          && this.stepThreeCompleted
          && !this.invalidLoadRate;
    },
    loadedDistanceBilledRate() {
      return this.distanceRate(this.billableAmount, this.loadedMiles);
    },
    userCompanies() {
      return _.get(this.userProfile, 'companyAccounts', []);
    },
    originatorCompanies() {
      // User has CREATE LISTING permission and company producer info
      const filteredCompanies = _.filter(this.visibleCompanies,
        company => (this.isLtnAdmin ||
          accountHasCreateListingPermission(this.findCompanyAccount()(company.id)))
          && hasProducerInfo(company));

      return this.formatCompaniesList(filteredCompanies);
    },
    companiesWithCDNMembers() {
      // User has DISPATCH permission and company CDN members
      const filteredCompanies = _.filter(this.visibleCompanies,
        company => (this.isLtnAdmin ||
          accountHasOfficePermission(this.findCompanyAccount()(company.id)))
          && hasCDNMembers(company));

      return this.formatCompaniesList(filteredCompanies);
    },
    truckingCompanies() {
      // User has SCHEDULER permission and company is a trucking company
      const filteredCompanies = _.filter(this.visibleCompanies,
        company => (this.isLtnAdmin ||
          accountHasOfficePermission(this.findCompanyAccount()(company.id)))
          && isTruckingCompany(company));

      return this.formatCompaniesList(filteredCompanies);
    },
    ownerCompany() {
      return this.ownerCompanyId ?
        _.find(this.visibleCompanies, { id: this.ownerCompanyId }) : null;
    },
    customerGroups() {
      let count = 1;

      if (this.ownerCompanyHasQbConnected) {
        count++;
      }

      return count;
    },
    ownerCompanyHasAccountingExportsEnabled() {
      return false && this.ownerCompanyHasQbConnected;
    },
    ownerCompanyHasQbConnected() {
      return this.ownerCompany && this.isQuickbooksConnected(this.ownerCompany);
    },
    companyStatus() {
      return _.get(this.ownerCompany, 'accountStatus');
    },
    companyDisabledSince() {
      return _.get(this.companyStatus, 'disabledSince');
    },
    isDisabled() {
      return !_.isEmpty(this.companyDisabledSince);
    },
    allCdnSelected() {
      return this.selectedMembers.length === this.cdnMembers.length;
    },
    icon() {
      if (this.allCdnSelected) return 'check_box';
      if (this.selectedMembers.length > 0 && !this.allCdnSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    companyRequiresDeliveryPaperwork() {
      const company = _.chain(this.originatorCompanies)
        .filter(c => c.companyId === this.ownerCompanyId)
        .first();
      const legacy = this.companyPluginLegacyLoadRequirements(company)
      return _.get(legacy, 'requireDeliveryPaperwork', null);
    },
  },
  watch: {
    originLocation(newLoc) {
      this.originPlaceId = newLoc ? newLoc.place_id : null;
      if (this.destinationPlaceId !=null && this.originPlaceId != null) {
        API.map.getDistance(this.originLocation.place_id, this.destinationLocation.place_id)
          .then((miles) => {
            this.loadedMiles = miles;
          });
      }
    },
    destinationLocation(newLoc) {
      this.destinationPlaceId = newLoc ? newLoc.place_id : null;
      if (this.destinationPlaceId !=null && this.originPlaceId != null) {
        API.map.getDistance(this.originLocation.place_id, this.destinationLocation.place_id)
          .then((miles) => {
            this.loadedMiles = miles;
          });
      }
    },
    currentStep(val) {
    },
    originatorCompanies(newValue) {
      if (newValue && newValue.length === 1) {
        this.ownerCompanyId = newValue[0].companyId;
      }
    },
    hasCustomerCompany(newValue) {
      this.$validator.validate();
    },
  },
  methods: {
    ...mapGetters('profiles', [
      'findCompanyAccount',
    ]),
    formatCompaniesList(companies) {
      // eslint-disable-next-line
      return companies.map((company) => {
        return {
          companyDisplayName: company.companyName,
          companyId: company.id,
        };
      });
    },
    selectAllCDNMembers() {
      this.$nextTick(() => {
        if (this.allCdnSelected) {
          this.selectedMembers = [];
        } else {
          this.selectedMembers = this.cdnMembers.slice();
        }
      });
    },
    formatPickupTime() {
      return Timestamps.localizedTimestamp(this.pickupTime);
    },
    handleOriginChange(placeOptions) {
      this.$set(this, 'originLocation', { ...placeOptions, description: placeOptions.formatted_address });
    },
    handleDestinationChange(placeOptions) {
      this.$set(this, 'destinationLocation', { ...placeOptions, description: placeOptions.formatted_address });
    },
    // true to put on the loadboard in one fell swoop
    async postLoad() {
      // add a checkbox on confirmation screen to post to load board
      this.createLoadBoardPosting = false;
      this.loadingBtn = true;

      const isValid = await this.$validator.validateAll('customerValidations');

      try {
        if (isValid) {
          const details = this.createListingDetails();

          const apiResponse = await API.company.postLoadV2({
            companyId: this.ownerCompanyId,
            body: details,
          });

          this.$store.dispatch('plannedLoads/getPlannedLoads', this.ownerCompanyId);
          this.createLoadBoardPosting = false;

          // Show loading tab
          this.$router.push({
            name: 'company.loads.planner',
            params: {
              id: this.ownerCompanyId,
              loadGroupId: apiResponse.data.humanId,
            },
          });
        }
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    createListingDetails() {
      let customer;
      if (this.customerCompany && typeof this.customerCompany === 'object') {
        customer = {
          companyName: this.customerCompany.companyName,
          companyId: this.customerCompany.id,
        };
      } else if (this.customerQbCompany && typeof this.customerQbCompany === 'object') {
        // if this is mapped to a LTN account though ...
        customer = {
          companyName: this.customerCompanyName(customerQbCompany),
          accountVendorId: this.customerQbCompany.qbCompanyId,
          accountVendorSource: 'QUICKBOOKS',
        };
      } else if (this.customerCompany) {
        customer = {
          companyName: this.customerCompany,
        };
      }

      return {
        ownerCompanyId: this.ownerCompanyId,
        driverInstructions: this.driverInstructions,
        dispatchInstructions: this.dispatchInstructions,
        loadCount: this.loadCount,
        loadedMiles: this.loadedMiles,
        pickupTime: this.formatPickupTime(),
        originNames: [this.originLocation.description],
        originPlaceIds: [this.originLocation.place_id],
        destinationPlaceId: this.destinationLocation.place_id,
        destinationName: this.destinationLocation.description,
        requireWashout: this.requireWashout,
        requireWeatherboards: this.requireWeatherboards,
        requireWoodChips: this.requireWoodChips,
        publishToLoadBoard: this.createLoadBoardPosting,
        billableAmount: this.billableAmount,
        unitsOfMeasure: this.unitsOfMeasure,
        customer,
        requireDeliveryDocument: this.companyRequiresDeliveryPaperwork,
      };
    },
    async loadCompanies() {
      this.loadingCompanies = true;
      await this.$store.dispatch('companies/getAllCompanies');
      // this.loadingCompanies = false;
    },
  },
  created() {
    window.__insp.push(['tagSession', 'open_post_load']);
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'post_load',
    });
    this.ownerCompanyId = this.$route.params.id;
    if (!this.ownerCompanyId && this.originatorCompanies && this.originatorCompanies.length === 1) {
      this.ownerCompanyId = this.originatorCompanies[0].companyId;
    }
    this.loadCompanies();
  },
};
</script>

<style lang="css" scoped>
  @media (max-width: 960px) {
    .hide-when-sticky-footer-visible {
      display: none;
    }
  }
</style>

<style lang="css">
  .optional-details-checkbox{
    display: flex;
    align-items: center;
    padding-top: 20px;
  }
  .optional-details-tile{
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PostLoad.vue